<template>
  <div>
    <b-card>
      <b-row
        v-for="car in carList"
        :key="car.CODE"
        :id="car.CODE"
        class="card-text mt-2">
        <b-col>
          <b-row>
            <b-col md="4">
              {{ car.CAR_DETAIL.NAME }}
            </b-col>
            <b-col md="2">
              {{ car.CAR_DETAIL.LICENSE_PLATE }}
            </b-col>
            <b-col md="2">
              <span>Average Rating:</span>
            </b-col>
            <b-col md="2">
              <span
                v-show="car.AVERAGE_RATING < 1"
                class="badge badge-danger">Not yet rated</span>
              <star-rating
                v-show="car.AVERAGE_RATING > 0"
                :increment="0.5"
                v-model="car.AVERAGE_RATING"
                :star-size="16"
                :show-rating="false"
                :read-only="true"
                class="align-top"
                inline/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'CarsView',
  components: {
    StarRating
  },
  props: {
    cars: {
      type: Array,
      default: () => []
    },
    carInStations: {
      type: Array,
      default: () => []
    },
    carLogs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      carList: this.cars,
      logs: this.carLogs
    }
  },
}
</script>
